export default {
  demo: {
    title: 'Boka en demo',
    description: 'Fyll i formuläret så kontaktar vi dig för att boka en personlig demo av AirPark-portalen.',
    form: {
      name: 'Namn',
      company: 'Företag/Organisation',
      email: 'E-post',
      phone: 'Telefon',
      segment: 'Typ av verksamhet',
      segments: {
        property: 'Fastighetsägare',
        brf: 'Bostadsrättsförening',
        municipality: 'Kommun',
        event: 'Evenemang/Arena',
        other: 'Annat',
      },
      message: 'Meddelande (valfritt)',
      submit: 'Skicka förfrågan',
      success: 'Tack! Vi återkommer inom kort.',
    },
  },
  about: {
    hero: {
      title: 'Om AirPark',
      description: 'AirPark är ett svenskt mjukvarubolag som utvecklar digitala affärssystem för professionell parkeringshantering. Vår plattform hjälper fastighetsägare, parkeringsbolag, bostadsrättsföreningar och kommuner att effektivisera administration, öka nyttjandet och skapa mer värde av befintliga parkeringsytor.',
    },
    underutilized: {
      title: 'Parkering är en underutnyttjad resurs',
      description: 'Parkering har länge hanterats med manuella processer, separata system och begränsad insyn. Samtidigt står stora delar av befintliga parkeringsytor tomma delar av dygnet – medan efterfrågan i andra sammanhang är hög.',
      insight: 'AirPark grundades ur insikten att parkering behöver hanteras som en affärs- och samhällsresurs, inte som en administrativ kostnad.',
    },
    digitalSystem: {
      title: 'Ett digitalt affärssystem för parkering',
      description: 'AirPark erbjuder en digital helhetslösning som samlar hela parkeringsverksamheten i ett system – från tillstånd, uthyrning och betalningar till kontroll, data och uppföljning.',
      platformTitle: 'Plattformen är utvecklad för att:',
      benefits: {
        reduceAdmin: 'Automatisera administrationen',
        enableSharing: 'Möjliggöra samnyttjande och andrahandsuthyrning',
        increaseTransparency: 'Öka transparens och beslutsstöd',
        supportSustainability: 'Stödja en mer hållbar stadsutveckling',
      },
    },
    customers: {
      title: 'Utvecklat för professionella aktörer',
      description: 'Gemensamt för våra kunder är behovet av struktur, kontroll och skalbarhet – oavsett om det gäller en enskild fastighet eller ett helt stadsområde.',
      usedBy: 'AirPark används av:',
      types: {
        propertyOwners: 'Fastighetsägare',
        parkingCompanies: 'Parkeringsbolag',
        coops: 'Bostadsrättsföreningar',
        municipalities: 'Kommuner',
        parkingOwners: 'Parkerings- och anläggningsägare',
      },
    },
    journey: {
      title: 'AirParks resa',
      description: 'Från idé till digitalt affärssystem för parkering',
      milestones: {
        founded: {
          year: '2021',
          title: 'Idén föds',
          description: 'AirPark grundas av Kim Olsson, med visionen om ett "Airbnb för parkeringar" – en plattform som maximerar nyttjandet av parkeringsytor och skapar nya intäkter för fastighetsägare, BRF:er och privatpersoner.',
        },
        development: {
          year: '2022',
          title: 'Utveckling',
          description: 'En skalbar plattform utvecklas tillsammans med branschexpertis, med fokus på digitalisering, automatisering och enkel parkeringsadministration.',
        },
        pilot: {
          year: '2023',
          title: 'Pilotprojekt & bevisad affär',
          description: 'Framgångsrika pilotprojekt, bland annat i Oceanhamnen och Rögle BK:s eventparkering, bekräftar plattformens potential och affärsmodellens skalbarhet.',
        },
        establishment: {
          year: '2025',
          title: 'Strategisk etablering',
          description: 'Plattformen vidareutvecklas till en helhetslösning för parkering. Strategiska samarbeten etableras och AirPark positioneras som en långsiktig partner för fastighetsägare, BRF:er och kommuner.',
        },
        today: {
          year: '2026',
          title: 'Digitalt affärssystem för parkering',
          description: 'AirPark är idag ett komplett, digitalt och automatiserat affärssystem som effektiviserar driften av parkeringsbestånd och hjälper kunder att öka driftnettot med minimal insats.',
        },
      },
    },
    future: {
      title: 'Vår syn på framtidens parkering',
      description: 'Vi tror att framtidens parkering bygger på:',
      points: {
        utilization: 'Bättre nyttjande av befintliga resurser',
        digital: 'Digital och automatiserad styrning - ökad nyttjandegrad av befintliga resurser istället för nybyggnation',
        sharing: 'Samnyttjande mellan olika användargrupper',
        environment: 'Minskad söktrafik och lägre miljöpåverkan',
      },
      conclusion: 'AirPark utvecklas kontinuerligt för att möta dessa behov och vara en långsiktig partner i utvecklingen av smartare städer och fastigheter.',
    },
    cta: {
      title: 'Vill du veta mer?',
      description: 'Kontakta oss så berättar vi mer om hur AirPark kan hjälpa dig.',
    },
  },
  nav: {
    whoAreYou: 'Vem är du?',
    products: 'Produkter',
    caseStudies: 'Kundcase',
    aboutAirPark: 'Om AirPark',
    park: 'Parkera',
    faq: 'Vanliga frågor',
    news: 'Nyheter',
    portal: 'AirPark-portalen',
    individual: 'Privatperson',
    propertyOwner: 'Fastighetsägare',
    coop: 'Bostadsrättsförening',
    event: 'Eventarrangör',
    municipality: 'Kommun',
    parkingCompany: 'Parkeringsbolag',
    airparkPortal: 'AirPark Portal',
    airparkApp: 'AirPark App',
    airpass: 'AirPass',
    bookDemo: 'Boka demo',
    caseOceanhamnen: 'Oceanhamnen',
    caseRogle: 'Rögle BK',
    caseLkp: 'Lunds Kommuns Parkering',
  },
  hero: {
    title: 'Parkeringssystemet som automatiserar affären\noch skapar värdet av varje parkeringsplats',
    subtitle: 'SAMLA ALL PARKERINGSADMINISTRATION I ETT SYSTEM',
    subtitlePart2: '',
    description: 'AirPark är det digitala affärssystemet som hjälper fastighetsägare, parkeringsbolag, BRF:er och kommuner att automatisera och effektivisera driften av parkeringsbeståndet.',
    propertyOwner: 'Skapa nya intäkter och öka värdet på era fastigheter med AirPark',
    bookDemo: 'Boka demo',
    learnMore: 'Utforska AirPark appen',
    valueProps: {
      efficiency: 'Effektivisera administrationen',
      utilization: 'Högre nyttjandegrad av befintliga parkeringar',
      datadriven: 'Datadriven parkeringsstyrning',
    },
  },
  problem: {
    title: 'Parkeringshantering är ofta uppdelad i flera system',
    description: 'Idag sköts parkering ofta manuellt i flera olika system av olika leverantörer. Det tar mycket tid, kostar pengar och ger dålig överblick. Vilket ofta ökar risken för manuella fel.',
    solutionTitle: 'AirPark – hela parkeringsflödet, helt automatiserat',
    solution: 'AirPark samlar tillstånd, uthyrning, betalningar, access och uppföljning i ett enda system. Allt sker automatiskt – från bokning till intäkt.',
    benefits: {
      lessAdmin: 'Upp till 80% mindre administration',
      fullControl: 'Full kontroll på beläggning och intäkter - i realtid',
      newRevenue: 'Nya intäktsmöjligheter utan manuellt arbete',
      onePlatform: 'En plattform istället för flera leverantörer',
    },
    cta: 'Boka Demo – Se hur AirPark automatiserar parkeringen.',
  },
  features: {
    title: 'Automatisera hela parkeringsaffären',
    subtitle: 'Allt som krävs för att digitalisera, styra och effektivisera parkeringsverksamheten – från tillstånd och uthyrning till betalningar, kontroll och uppföljning.',
    allInOne: {
      title: 'Allt-i-ett-system',
      description: 'Samla hela parkeringsverksamheten i AirPark Portal. Dashboard, statistik, användare och betalningar – i ett gemensamt affärssystem.',
    },
    subletting: {
      title: 'Andrahandsuthyrning',
      description: 'Gör det möjligt för hyresgäster och boende att hyra ut sina platser när de inte används. Öka nyttjandegraden och skapa mer värde.',
    },
    priceAvailability: {
      title: 'Smart prissättning',
      description: 'Styr prissättning baserat på efterfrågan och tid. Optimera intäkterna utan manuell handpåläggning.',
    },
    marketplace: {
      title: 'Marketplace',
      description: 'Tillgängliggör vakanta platser direkt i AirPark-appen och hyr ut dem till slutkund via AirParks Marketplace – helt automatiserat, utan extra administration.',
    },
    controlFees: {
      title: 'Kontrollavgifter',
      description: 'Hantera kontrollavgifter digitalt med tydlig uppföljning och mindre administration.',
    },
    airparkPay: {
      title: 'Automatisk betalning',
      description: 'All betalningshantering sker automatiskt – från fakturering till påminnelser och uppföljning.',
    },
    queueManagement: {
      title: 'Köhantering',
      description: 'Digital hantering av köer och väntelistor. Transparens, automatiska notifieringar och rättvis tilldelning.',
    },
    airpass: {
      title: 'AirPass',
      description: 'Digital åtkomst till garage och portar. Användare öppnar via appen – inga nycklar eller fjärrkontroller.',
    },
    charging: {
      title: 'Elbilsladdning',
      description: 'Hantera laddplatser som en del av parkeringsaffären. Styr tillgänglighet, användning och prissättning av elbilsladdning direkt i AirPark.',
    },
  },
  calculator: {
    title: 'Inkomstberäkning',
    parking: 'parkering',
    parkings: 'parkeringar',
    hour: 'timme',
    month: 'månad',
    year: 'år',
    youCanEarn: 'Du kan tjäna cirka',
    disclaimer: '*Siffran är en uppskattning baserad på genomsnittsvärden. Av dessa ska en del gå till skatt och en annan till avgifter för AirParks förmedling.',
  },
  pricing: {
    title: 'Prissättning',
    rentOut: {
      title: 'Hyr ut din parkeringsplats',
      description: 'AirPark tar ut en avgift på 20% av det fakturerade beloppet.',
      price: '20%',
    },
    permit: {
      title: 'Parkeringstillstånd',
      description: 'AirPark tar ut en avgift på 7% av det fakturerade beloppet.',
      price: '7%',
    },
    controlFee: {
      title: 'Kontrollavgifter',
      description: '50% av det fakturerade beloppet går till AirPark.',
      price: '50%',
    },
    airpass: {
      title: 'AirPass',
      description: '*En startavgift på 7 995 SEK krävs och en avtalsperiod på 12 månader.',
      price: '235 SEK/månad*',
    },
  },
  getStarted: {
    title: 'Kom igång med AirPark',
    manage: {
      title: 'Hantera parkering som en affär',
      description: 'För fastighetsägare, bostadsrättsföreningar och förvaltare som vill automatisera parkeringshanteringen, minska administrationen och öka intäkterna med AirPark.',
      cta: 'Läs mer',
    },
    rentOut: {
      title: 'Hyr ut parkering',
      description: 'Har du en parkeringsplats som inte används hela tiden? Med AirPark kan du hyra ut den till grannar eller andra användare – helt automatiskt, kontrollerat och spårbart.',
      cta: 'Läs mer',
    },
    park: {
      title: 'Parkera med AirPark',
      description: 'Parkera enkelt och digitalt med AirPark. Hitta, förboka och betala parkering helt digitalt, även på platser som tidigare varit otillgängliga – direkt i appen.',
      cta: 'Läs mer',
    },
  },
  caseStudy: {
    title: 'Kundcase',
    oceanhamnen: {
      title: 'Oceanhamnen',
      description: 'Med AirPark blir parkeringen i Oceanhamnen en intäktsdrivande, fullt digital tjänst – utan investeringar i ny infrastruktur.',
      benefits: {
        benefit1: 'Nya intäkter från tidigare outnyttjade parkeringsplatser',
        benefit2: 'Samnyttjande mellan boende, besökare och verksamheter',
        benefit3: 'Digital och automatiserad parkeringshantering i ett gemensamt system',
        benefit4: 'Etablerat en ny andrahandsmarknad för parkering – med helt nya intäktsmöjligheter',
      },
      cta: 'Läs mer om Oceanhamnen',
    },
    rogle: {
      title: 'Rögle BK',
      description: 'Med AirPark kunde Rögle hantera parkering digitalt vid hög belastning och samtidigt förbättra upplevelsen för besökare.',
      benefits: {
        benefit1: 'Smidigare parkeringsupplevelse vid evenemang',
        benefit2: 'Snabb implementering inför skarpa matchdagar',
        benefit3: 'Minskad administration för arrangören',
      },
      testimonial: 'Implementeringen gick otroligt smidigt – allt fungerade från dag ett.',
      author: 'Robin Westerling',
      authorTitle: 'Rögle',
      cta: 'Läs mer om Rögle',
    },
    lkp: {
      title: 'Lunds Kommuns Parkering AB',
      description: 'AirPark används som ett verktyg för att effektivisera parkeringshanteringen och tillgänglighet i stadsmiljö – med fokus på digitalisering och effektivt nyttjande av varje plats.',
      benefits: {
        benefit1: 'Digital hantering och optimering av parkeringsbeståndet',
        benefit2: 'Andrahandsuthyrning som ökar nyttjandegrad och intäkter för alla parter',
        benefit3: 'Förbokning och minskad söktrafik i stadsmiljö',
        benefit4: 'Samarbete mellan kommun och privata aktörer',
      },
      cta: 'Läs mer om samarbetet',
    },
  },
  footer: {
    title: 'Gå med i den nya parkeringsgemenskapen',
    contactUs: 'Kontakta oss',
    privacyPolicy: 'Integritetspolicy',
    cookiePolicy: 'Cookiepolicy',
    terms: 'Villkor',
    cta: {
      title: 'Vill ni lägga mindre tid på administration och få mer betalt för parkeringen?',
      description: 'Boka en kostnadsfri demo och se hur AirPark fungerar i praktiken.',
      button: 'Boka demo',
    },
  },
  common: {
    downloadApp: 'AirPark-appen',
    downloadAppDescription: 'AirPark-appen är gränssnittet för era parkeringskunder. Här kan de boka parkering, köpa tillstånd, hyra ut sin plats och hantera betalningar – allt kopplat till ert parkeringsområde via AirPark Portal.',
    portalDescription: 'Om du har flera parkeringsplatser eller parkeringsområden är AirPark-portalen perfekt för dig. Det är enkelt att registrera sig och du kan komma igång idag med en enklare, effektivare och bättre parkeringslösning.',
    createAccount: 'Skapa ett konto',
    cancel: 'Avbryt',
    close: 'Stäng',
    loading: 'Laddar',
  },
  appSection: {
    title: 'En app för alla',
    subtitle: 'Gränssnittet för era parkeringskunder',
    description: 'AirPark appen gör det enkelt för hyresgäster och besökare att hitta, boka och betala för parkering – snabbt och smidigt. Hyresgäster kan själva hyra ut sin egen plats när den inte används. Här bokar de parkering, köper tillstånd, får access till garageportar, hyr ut sin plats i andra hand och hanterar betalningar – helt på egen hand.',
    description2: 'Allt är automatiskt kopplat till ert parkeringsområde via AirPark Portalen, vilket minimerar administrationen och säkerställer full kontroll och spårbarhet.',
    features: {
      booking: {
        title: 'Boka parkering',
        description: 'Kunder bokar och betalar själva – utan manuell hantering',
      },
      permits: {
        title: 'Digitala tillstånd',
        description: 'Tillstånd köps, hanteras och följs upp helt digitalt.',
      },
      subletting: {
        title: 'Andrahandsuthyrning',
        description: 'Hyresgäster hyr ut sin plats när den inte används – automatiskt, kontrollerat och spårbart. Resultat: högre nyttjandegrad och nya intäkter.',
      },
      airpass: {
        title: 'AirPass',
        description: 'Automatisk access till garage och portar – kopplat till bokning och tillstånd.',
      },
    },
    result: 'Resultatet: nöjdare parkeringskunder, mindre administration och en helt automatiserad parkeringsaffär.',
    cta: 'Ladda ner appen',
    ctaSubtext: 'Tillgänglig för iOS och Android',
  },
  consent: {
    title: 'Vi använder cookies',
    description: 'Vi använder cookies för att förbättra din upplevelse på vår webbplats, analysera trafik och visa relevanta annonser.',
    learnMore: 'Läs mer om cookies',
    settings: 'Inställningar',
    necessary: 'Endast nödvändiga',
    acceptAll: 'Acceptera alla',
    settingsTitle: 'Cookie-inställningar',
    save: 'Spara inställningar',
  },
  kpi: {
    title: 'AirPark i siffror',
    description: 'Vi hjälper fastighetsägare och BRF:er att maximera värdet av sina parkeringsplatser.',
    parkingSpaces: 'Parkeringsplatser',
    partners: 'Partners',
    satisfaction: 'Nöjda kunder',
    revenueIncrease: 'Ökad intäkt',
    disclaimer: '* Siffrorna är exempel och kommer att uppdateras med verklig data.',
  },
  portal: {
    section: {
      label: 'AirPark Portal',
      title: 'Full kontroll över parkeringen',
      description: 'AirPark Portal är navet i AirPark. Här hanteras uthyrning, tillstånd, betalningar, access och uppföljning – helt automatiserat i ett enda system. Resultatet är mindre administration, bättre överblick och full kontroll över nyttjandegrad och intäkter.',
      features: {
        dashboard: {
          title: 'Översiktlig dashboard',
          description: 'Samlad vy över beläggning, intäkter och status i realtid',
        },
        permits: {
          title: 'Digitala parkeringstillstånd & Kölistor',
          description: 'Effektiv, rättvis och helt digital tillstånds- och köhantering – mindre admin, mer kontroll med en fullt automatiserad process.',
        },
        subletting: {
          title: 'Direkt- och andrahandsuthyrning',
          description: 'Aktivera tomma platser och öka intäkterna när de inte används.',
        },
        billing: {
          title: 'Automatisk fakturering & betalningar',
          description: 'Mindre administration och säkra betalningsflöden',
        },
        controlFees: {
          title: 'Kontrollavgifter',
          description: 'Digital hantering av kontrollavgifter och regelverk',
        },
        automation: {
          title: 'Automatiserade processer',
          description: 'Färre manuella moment – mer tid till annat',
        },
      },
      cta: 'Boka demo',
      ctaSubtext: 'Se hur AirPark Portal fungerar i praktiken',
      learnMore: 'Läs mer om portalen',
      screenshotPlaceholder: 'Portal-screenshot',
      screenshotNote: 'Lägg till riktiga screenshots här',
    },
  },
  beforeAfter: {
    title: 'Hur AirPark skapar värde – varje dag',
    subtitle: 'Från manuell administration till digitalt affärssystem.',
    before: {
      title: 'Utan AirPark',
      items: {
        item1: 'Manuell hantering av tillstånd och kölistor',
        item2: 'Outnyttjade parkeringsplatser',
        item3: 'Tidskrävande fakturering och uppföljning',
        item4: 'Ingen överblick över beläggning och intäkter',
        item5: 'Svårt att erbjuda flexibla lösningar',
      },
    },
    after: {
      title: 'Med AirPark',
      items: {
        item1: 'Kraftigt minskad administration genom automatisering',
        item2: 'Fler uthyrda platser utan manuellt arbete',
        item3: 'Intäkter genereras och följs upp automatiskt',
        item4: 'Full kontroll och spårbarhet i realtid',
        item5: 'Nya intäktsmöjligheter via flexibel och digital uthyrning',
      },
    },
    result: 'Mindre administration, bättre kontroll och högre intäkter – helt automatiserat',
    closing: 'Används idag av fastighetsägare, parkeringsbolag, bostadsrättsföreningar och kommuner i Sverige',
  },
  contact: {
    title: 'Kontakta oss',
    description: 'Har du frågor eller vill komma igång med AirPark? Hör av dig så hjälper vi dig!',
    email: 'E-post',
    phone: 'Telefon',
    formTitle: 'Skicka ett meddelande',
    successMessage: 'Tack för ditt meddelande! Vi återkommer så snart som möjligt.',
    form: {
      name: 'Namn',
      email: 'E-postadress',
      phone: 'Telefonnummer',
      company: 'Företag (valfritt)',
      subject: 'Ämne',
      message: 'Meddelande',
      submit: 'Skicka meddelande',
      sending: 'Skickar...',
      requiredFields: 'Obligatoriska fält',
    },
    errors: {
      nameRequired: 'Namn är obligatoriskt',
      emailRequired: 'E-postadress är obligatorisk',
      emailInvalid: 'Ogiltig e-postadress',
      subjectRequired: 'Ämne är obligatoriskt',
      messageRequired: 'Meddelande är obligatoriskt',
      messageTooShort: 'Meddelandet måste vara minst 10 tecken',
    },
  },
  faq: {
    title: 'Vanliga frågor',
    description: 'Här hittar du svar på de vanligaste frågorna om AirPark',
    stillHaveQuestions: 'Har du fler frågor?',
    contactDescription: 'Hittar du inte svaret du letar efter? Kontakta oss så hjälper vi dig!',
    categories: {
      general: 'Allmänt',
      renting: 'Hyra ut',
      parking: 'Parkera',
      technical: 'Tekniskt',
    },
    general: {
      whatIsAirpark: {
        question: 'Vad är AirPark?',
        answer: 'AirPark är en plattform som gör det enkelt att hyra ut och boka parkeringsplatser. Med vår app och portal kan du hantera allt som rör parkering - smidigt, digitalt och fullt automatiserat.',
      },
      howDoesItWork: {
        question: 'Hur fungerar AirPark?',
        answer: 'Du laddar ner AirPark-appen, skapar ett konto och kan sedan antingen hyra ut din parkeringsplats eller boka en ledig plats. Allt sköts digitalt via appen.',
      },
      isFree: {
        question: 'Är det gratis att använda AirPark?',
        answer: 'Det är gratis att registrera sig och skapa ett konto.',
      },
      whoCanUse: {
        question: 'Vem kan använda AirPark?',
        answer: 'AirPark är för alla! Privatpersoner, bostadsrättsföreningar, fastighetsägare, företag, parkeringsbolag och kommuner kan alla använda vår plattform för att hantera sitt parkeringsbestånd.',
      },
    },
    renting: {
      howToRentOut: {
        question: 'Hur hyr jag ut min parkeringsplats?',
        answer: 'Ladda ner AirPark-appen, skapa ett konto, lägg till din parkeringsplats med bilder och beskrivning, sätt pris och tillgänglighet. Sedan är du igång!',
      },
      howMuchEarn: {
        question: 'Hur mycket kan jag tjäna?',
        answer: 'Det beror på platsens läge och efterfrågan. Många tjänar flera tusen kronor per år på oanvända parkeringsplatser.',
      },
      fees: {
        question: 'Vilka avgifter tar AirPark?',
        answer: 'AirPark tar en provision på 20% vid uthyrning av parkeringsplatser, 7% vid försäljning av parkeringstillstånd och 50% av kontrollavgifter.',
      },
      payment: {
        question: 'Hur får jag betalt?',
        answer: 'Betalningar sker automatiskt via appen. Pengarna sätts in automatiskt på ditt registrerade bankkonto.',
      },
    },
    parking: {
      howToBook: {
        question: 'Hur bokar jag en parkeringsplats?',
        answer: 'Öppna AirPark-appen, sök efter lediga platser i ditt område, välj den plats som passar dig bäst och bekräfta bokningen och betala. Du får sedan instruktioner för hur du hittar platsen.',
      },
      cancellation: {
        question: 'Kan jag avboka en bokning?',
        answer: 'Ja, du kan avboka en bokad parkeringsplats och få en återbetalning direkt.',
      },
      payment: {
        question: 'Hur betalar jag för parkering?',
        answer: 'All betalning sker säkert via appen med kort, swish eller faktura.',
      },
    },
    technical: {
      appAvailability: {
        question: 'Finns appen för både iOS och Android?',
        answer: 'Ja, AirPark-appen finns tillgänglig för både iOS i App Store och Android i Google Play.',
      },
      airpass: {
        question: 'Vad är AirPass?',
        answer: 'AirPass är en smart lösning för öppning av garageportar och dörrar. Med AirPass kan användare med giltigt parkeringstillstånd eller bokning få access till garaget direkt genom appen.',
      },
      support: {
        question: 'Hur kontaktar jag support?',
        answer: "Du kan kontakta vår support via mejl och telefon. hello{'@'}airpark.app, 010-641 18 68",
      },
    },
  },
  parkWithAirpark: {
    title: 'Parkera med AirPark',
    description: 'Använd AirPark för att enkelt boka en parkeringsplats i förväg, spara tid och pengar samtidigt som du bidrar till en mer hållbar framtid genom att minska bilavgaser och utsläpp.',
    sustainableParking: {
      title: 'Hållbar parkering',
      description: 'Genom att använda AirPark för att parkera din bil bidrar du till en mer hållbar framtid på flera sätt. Du kan enkelt hitta och boka en parkeringsplats i förväg, vilket minskar risken att behöva köra runt och leta efter en plats. Detta minskar dina bilavgaser och bidrar till att reducera utsläppen.',
    },
    flexibleOptions: {
      title: 'Flexibla parkeringsalternativ',
      description: 'Med AirPark kan du enkelt välja mellan olika parkeringsalternativ, beroende på dina behov. Om du till exempel bara behöver parkera för en kortare stund, kan du välja en tidsbegränsad plats. Om du behöver parkera under en längre period, till exempel över natten eller en hel månad, kan du välja dygnsparkering eller månadsparkering.',
    },
    centralLocations: {
      title: 'Centrala lägen',
      description: 'Med AirPark kan du enkelt hitta en central parkeringsplats nära din destination och boka den i förväg, vilket ger dig möjlighet att enkelt komma till dina destinationer utan att behöva leta efter parkering på gatan. Detta sparar dig tid och stress, eftersom du redan vet att du har en plats att parkera på när du anländer.',
    },
    parkingPermit: {
      title: 'Parkeringstillstånd',
      description: 'Med AirPark-appen har du tillgång till ett brett utbud av parkeringsplatser och parkeringstillstånd i närheten av där du bor eller arbetar. Allt hanteras enkelt inom appen, så det är bara att ladda ner och börja använda. Så spara tid och stress, ladda ner AirPark-appen idag för att hitta den parkering som passar dig bäst!',
    },
    moreQuestions: 'Fler frågor?',
    moreQuestionsDescription: 'Om du vill komma igång med AirPark är du välkommen att höra av dig till oss! Vi ser fram emot att hjälpa dig att få en bra start med vår tjänst. Hör av dig så berättar vi mer och hjälper dig att komma igång.',
  },
  individual: {
    hero: {
      title: 'Parkering för privatpersoner',
      description: 'Med AirPark kan du enkelt hyra ut din parkeringsplats eller hitta och boka parkering nära dig. Tjäna pengar på din oanvända plats eller förboka den perfekta parkeringen och slipp sökkörandet.',
    },
    benefits: {
      title: 'Fördelar för dig som privatperson',
      description: 'AirPark gör det enkelt att hantera parkering, oavsett om du vill hyra ut eller hitta en plats.',
    },
    features: {
      rentOut: {
        title: 'Hyr ut din plats',
        description: 'Har du en parkeringsplats som står tom? Hyr ut den och tjäna extra pengar varje månad.',
      },
      easyBooking: {
        title: 'Enkel bokning',
        description: 'Boka parkering på några sekunder direkt i appen. Inga krångliga processer.',
      },
      secure: {
        title: 'Säkra betalningar',
        description: 'Alla betalningar hanteras säkert via appen. Du får pengarna direkt till ditt konto.',
      },
      findParking: {
        title: 'Hitta parkering',
        description: 'Sök bland tusentals parkeringsplatser nära din destination och boka i förväg.',
      },
      flexible: {
        title: 'Flexibla tider',
        description: 'Hyr per timme, dag eller månad. Du väljer vad som passar dig bäst.',
      },
      prebook: {
        title: 'Förboka parkering',
        description: 'Slipp stressa och leta efter parkeringsplatser. Förboka din plats i förväg och vet att du har parkering när du anländer.',
      },
    },
    howItWorks: {
      title: 'Så fungerar det',
      step1: {
        title: 'Ladda ner appen',
        description: 'Hämta AirPark-appen gratis från App Store eller Google Play.',
      },
      step2: {
        title: 'Skapa ett konto',
        description: 'Registrera dig på några sekunder med ditt telefonnummer.',
      },
      step3: {
        title: 'Börja parkera eller hyr ut',
        description: 'Sök efter lediga platser eller lägg upp din egen plats för uthyrning.',
      },
    },
    appPreview: 'AirPark-appen',
    prebook: {
      title: 'Förboka och slipp stressen',
      description: 'Med AirPark kan du förboka din parkeringsplats i förväg, du slipper köra runt och leta och kan parkera tryggt och säkert på din förbokade plats.',
    },
    downloadApp: 'Ladda ner appen',
  },
  propertyOwner: {
    hero: {
      title: 'Gör parkering till en lönsam affärsresurs',
      description: 'Med AirPark samlas uthyrning, tillstånd, betalningar och uppföljning i ett helt automatiserat affärssystem – som ger full kontroll över nyttjandegrad, intäkter och administration.',
    },
    benefits: {
      title: 'Fördelar för fastighetsägare',
      description: 'AirPark ger dig verktygen för att hantera parkering professionellt och effektivt.',
      bullet1: 'Öka intäkterna med upp till 40 % genom smart och flexibel uthyrning*',
      bullet2: 'Automatiserad fakturering och betalningshantering',
      bullet3: 'Realtidsöverblick över beläggning, intäkter och användning',
      bullet4: 'Full kontroll och spårbarhet',
      bullet5: 'Nya intäktskanaler genom andrahandsuthyrning och samnyttjande',
      disclaimer: '*Resultat varierar beroende på fastighet och användning',
    },
    features: {
      management: {
        title: 'Enkel hantering',
        description: 'Hantera alla dina parkeringsplatser från en central portal. Överblick över beläggning och intäkter.',
      },
      revenue: {
        title: 'Ökade intäkter',
        description: 'Maximera intäkterna från dina parkeringsplatser genom smart prissättning och uthyrning.',
      },
      analytics: {
        title: 'Statistik och rapporter',
        description: 'Få detaljerad statistik över användning, intäkter och trender för dina parkeringsplatser.',
      },
      access: {
        title: 'Communitys',
        description: 'Styr vem som har tillgång till dina parkeringsplatser med AirPark Communities.',
      },
      permits: {
        title: 'Parkeringstillstånd',
        description: 'Sälj och hantera parkeringstillstånd digitalt. Slipp pappersarbete och manuell administration.',
      },
      controlFees: {
        title: 'Kontrollavgifter',
        description: 'Utfärda kontrollavgifter för felparkerade fordon direkt via appen.',
      },
    },
    portal: {
      title: 'AirPark-portalen',
      description: 'Med AirPark-portalen får du ett kraftfullt verktyg för att hantera alla aspekter av din parkeringsverksamhet – helt automatiserat.',
      feature1: 'Överblick över alla parkeringsplatser',
      feature2: 'Hantera hyresgäster och tillstånd',
      feature3: 'Automatisk fakturering',
      feature4: 'Detaljerade rapporter och statistik',
    },
    portalPreview: 'AirPark Portal',
  },
  coop: {
    hero: {
      title: 'Skapa mer värde av föreningens parkeringsplatser',
      description: 'Skapa mer värde av föreningens parkeringsplatser genom kontrollerad och digital samnyttjande. Med AirPark kan boende hyra ut sina platser när de inte används – helt automatiserat – samtidigt som föreningen behåller full kontroll och får del av intäkterna. Systemet är skalbart och anpassat för både små och stora föreningar, utan ökad administration.',
    },
    benefits: {
      title: 'Fördelar för bostadsrättsföreningar',
      description: 'AirPark hjälper er förening att hantera parkering effektivt och rättvist.',
    },
    features: {
      memberManagement: {
        title: 'Medlemshantering',
        description: 'Hantera vilka medlemmar som har tillgång till parkeringsplatser och tillstånd.',
      },
      subletting: {
        title: 'Andrahandsuthyrning',
        description: 'Låt medlemmar hyra ut sina platser när de inte används. Enkelt och kontrollerat.',
      },
      waitlist: {
        title: 'Köhantering',
        description: 'Hantera kön till parkeringsplatser rättvist och transparent för alla medlemmar.',
      },
      billing: {
        title: 'Automatisk fakturering',
        description: 'Slipp manuell fakturering. AirPark hanterar betalningar automatiskt.',
      },
      communities: {
        title: 'Slutna gemenskaper',
        description: 'Skapa en sluten parkeringsgemenskap endast för era medlemmar.',
      },
      overview: {
        title: 'Komplett överblick',
        description: 'Se status för alla parkeringsplatser, tillstånd och betalningar i realtid.',
      },
    },
    cta: {
      title: 'Kom igång med AirPark',
      description: 'Registrera din förening idag och börja förenkla parkeringshanteringen.',
    },
  },
  event: {
    hero: {
      title: 'Parkeringslösningar för eventarrangörer',
      description: 'Ge dina besökare en smidig parkeringsupplevelse. Med AirPark kan du hantera eventparkering, förbokning och belöningar.',
    },
    benefits: {
      title: 'Fördelar för eventarrangörer',
      description: 'AirPark hjälper dig att skapa en bättre upplevelse för dina eventbesökare.',
    },
    features: {
      eventParking: {
        title: 'Eventparkering',
        description: 'Skapa dedikerade parkeringsområden för dina event med anpassade priser och tider.',
      },
      prebooking: {
        title: 'Förbokning',
        description: 'Låt besökare boka parkering i förväg för att garantera en plats.',
      },
      rewards: {
        title: 'Belöningssystem',
        description: 'Belöna dina besökare med rabatter och tävlingar via AirPark Rewards.',
      },
      capacity: {
        title: 'Kapacitetshantering',
        description: 'Håll koll på beläggning i realtid och undvik överfulla parkeringar.',
      },
      payment: {
        title: 'Smidig betalning',
        description: 'Besökare betalar enkelt via appen. Inga kontanter eller biljettautomater.',
      },
      digital: {
        title: 'Helt digitalt',
        description: 'Slipp fysiska parkeringsbiljetter. Allt hanteras digitalt i appen.',
      },
    },
    cta: {
      title: 'Förbättra din eventparkering',
      description: 'Kontakta oss för att diskutera hur AirPark kan hjälpa ditt nästa event.',
    },
    caseStudyImage: 'Rögle BK Arena',
  },
  municipality: {
    hero: {
      title: 'Digital styrning för kommunal parkeringshantering',
      description: 'AirPark är ett digitalt styrsystem för kommunal parkeringshantering. Genom att samla tillstånd, kö-listor, andrahandsuthyrning, garageaccess, och uppföljning i ett automatiserat system ökar nyttjandegraden av befintliga parkeringsytor – vilket minskar söktrafik, utsläpp och behovet av nya parkeringsanläggningar.',
    },
    benefits: {
      title: 'Fördelar för kommuner',
      description: 'AirPark hjälper kommuner att skapa smartare och mer hållbara parkeringslösningar.',
    },
    features: {
      publicParking: {
        title: 'Offentlig parkering',
        description: 'Hantera kommunala parkeringsplatser digitalt med realtidsövervakning.',
      },
      sustainability: {
        title: 'Hållbarhet',
        description: 'Minska utsläpp genom att hjälpa förare hitta parkering snabbare.',
      },
      data: {
        title: 'Datadriven planering',
        description: 'Använd parkeringsdata för att fatta bättre beslut om stadsplanering.',
      },
      charging: {
        title: 'Laddinfrastruktur',
        description: 'Integrera laddstationer för elbilar i parkeringslösningen.',
      },
      permits: {
        title: 'Digitala tillstånd',
        description: 'Hantera tillstånd helt digitalt.',
      },
      integration: {
        title: 'Systemintegration',
        description: 'Integrera med befintliga kommunala system och tjänster.',
      },
    },
    stats: {
      emissions: 'Minskade utsläpp från parkeringssökande',
      efficiency: 'Ökad effektivitet i parkeringshantering',
      availability: 'Tillgänglighet för medborgarna',
    },
    cta: {
      title: 'Modernisera kommunens parkering',
      description: 'Kontakta oss för att diskutera hur AirPark kan hjälpa er kommun.',
    },
  },
  parkingCompany: {
    hero: {
      title: 'Utöka och effektivisera erbjudandet med ett digitalt affärssystem',
      description: 'AirPark kompletterar traditionell parkeringsdrift genom att automatisera uthyrning, tillstånd, betalningar och kundhantering. Resultatet är nya intäktsmöjligheter, ökad nyttjandegrad av befintliga parkeringsytor och en skalbar verksamhet som kan växa utan ökad administration.',
    },
    benefits: {
      title: 'Fördelar för parkeringsbolag',
      description: 'AirPark kompletterar er verksamhet med digital uthyrning och tillståndshantering.',
    },
    features: {
      digitalRental: {
        title: 'Digital uthyrning',
        description: 'Erbjud digital uthyrning av parkeringsplatser som komplement till er övervakning.',
      },
      permits: {
        title: 'Tillståndshantering',
        description: 'Hantera parkeringstillstånd digitalt med automatisk förnyelse och fakturering.',
      },
      billing: {
        title: 'Automatisk fakturering',
        description: 'Slipp manuell fakturering. AirPark hanterar betalningar automatiskt.',
      },
      controlFees: {
        title: 'Kontrollavgifter',
        description: 'Integrera kontrollavgiftshantering med övrig parkeringsverksamhet.',
      },
      customerService: {
        title: 'Kundhantering',
        description: 'Samla alla kunder, ärenden och kommunikation i ett system.',
      },
      scalable: {
        title: 'Skalbar plattform',
        description: 'Lägg enkelt till nya områden och uppdrag utan att byta system.',
      },
    },
    portal: {
      title: 'AirPark-portalen för parkeringsbolag',
      description: 'Med AirPark-portalen får ni ett kraftfullt verktyg för att hantera alla aspekter av er parkeringsverksamhet.',
      feature1: 'Överblick över alla parkeringsområden',
      feature2: 'Hantera kunder och tillstånd',
      feature3: 'Automatisk fakturering och betalningar',
      feature4: 'Detaljerade rapporter och statistik',
    },
    portalPreview: 'AirPark Portal',
  },
  airparkPortal: {
    hero: {
      title: 'AirPark Portal',
      description: 'Det kompletta verktyget för att hantera parkeringsplatser, tillstånd och intäkter. Perfekt för fastighetsägare, föreningar och företag.',
    },
    overview: {
      title: 'Allt du behöver på ett ställe',
      description: 'AirPark portalen ger er full kontroll över ert parkeringsbestånd, med automatiserade verktyg och effektiv hantering.',
    },
    features: {
      dashboard: {
        title: 'Digitala parkeringstillstånd',
        description: 'Skapa, administrera och hantera parkeringstillstånd digitalt. Inga fysiska lappar eller manuella register.',
      },
      mapping: {
        title: 'Digital köhantering',
        description: 'Automatiserade kölistor med full transparens för boende och hyresgäster.',
      },
      users: {
        title: 'Andrahandsuthyrning av parkeringsplatser',
        description: 'Möjliggör kontrollerad andrahandsuthyrning via plattformen. Skapa nya intäkter utan ökad administration.',
      },
      billing: {
        title: 'Direktuthyrning av vakanta parkeringsplatser',
        description: 'Tillgängliggör tomma parkeringsplatser för bokning och öka beläggningen.',
      },
      reports: {
        title: 'Intäktsöversikt i realtid',
        description: 'Få full insyn i beläggning, intäkter och användningsgrad per parkeringsyta.',
      },
      settings: {
        title: 'Digital access & integration',
        description: 'Integrera med garageportar, laddstationer och befintliga system.',
      },
    },
    getStarted: {
      title: 'Kom igång på minuter',
      step1: {
        title: 'Skapa ett konto',
        description: 'Registrera dig gratis på portal.airpark.app.',
      },
      step2: {
        title: 'Lägg till parkeringsplatser',
        description: 'Kartlägg dina parkeringsplatser och sätt priser.',
      },
      step3: {
        title: 'Börja tjäna pengar',
        description: 'Publicera dina platser och börja ta emot bokningar.',
      },
    },
    screenshot: 'AirPark Portal Dashboard',
    freeToStart: 'Gratis att komma igång!',
    benefits: {
      benefit1: 'Digitala parkeringstillstånd',
      benefit2: 'Digital köhantering',
      benefit3: 'Andrahandsuthyrning av parkeringsplatser',
      benefit4: 'Intäktsöversikt i realtid',
    },
    whyPortal: {
      label: 'Varför AirPark Portal?',
      title: 'Allt du behöver för att hantera parkering',
      description: 'AirPark Portal är det smidiga verktyget som ger dig full kontroll över din parkeringsverksamhet. Oavsett om du hanterar 10 eller 10 000 platser får du samma kraftfulla funktioner.',
    },
    problemsSolved: {
      title: 'Vilka problem löser AirPark portalen?',
      problem: {
        subtitle: 'Manuell och ineffektiv parkeringsadministration?',
        intro: 'Många fastighetsägare och BRF:er hanterar parkering genom:',
        list: {
          excel: 'Excel-listor',
          queues: 'Manuella kölistor',
          permits: 'Fysiska tillstånd',
          payments: 'Separata betalningslösningar',
          admin: 'Tidskrävande administration',
        },
        leadsTo: 'Det leder till:',
        consequences: {
          unnecessaryAdmin: 'Onödig administration',
          lackOfOverview: 'Brist på överblick',
          missedRevenue: 'Missade intäkter',
          sublettingControl: 'Svårt att kontrollera andrahandsuthyrning',
          insufficientData: 'Otillräcklig data kring beläggning och intäkter',
        },
        solution: 'AirPark Portal digitaliserar hela processen.',
      },
      solution: {
        subtitle: 'Öka intäkterna från befintliga parkeringsytor',
        intro: 'AirPark Portal gör det möjligt att:',
        list: {
          activate: 'Aktivera outnyttjade parkeringsplatser',
          subletting: 'Skapa nya intäktsströmmar via andrahandsuthyrning',
          charging: 'Ta betalt för laddning',
          pricing: 'Optimera prissättning baserat på efterfrågan',
        },
        conclusion: 'En parkeringsplats som står tom är en förlorad intäkt',
      },
    },
    targetAudience: {
      title: 'För vilka är AirPark Portal?',
      brf: {
        title: 'Bostadsrättsföreningar',
        description: 'Hantera föreningens parkeringsplatser med digital köhantering och kontrollerad andrahandsuthyrning.',
      },
      commercial: {
        title: 'Kommersiella fastighetsägare',
        description: 'Optimera intäkterna från parkeringsytor med automatiserad uthyrning och fakturering.',
      },
      parking: {
        title: 'Parkeringsbolag',
        description: 'Komplettera befintlig verksamhet med digitala tillstånd och uthyrning.',
      },
      municipality: {
        title: 'Kommuner',
        description: 'Digital hantering av parkeringstillstånd och uppföljning av parkeringsbeståndet.',
      },
    },
  },
  airparkApp: {
    hero: {
      title: 'AirPark-appen',
      subtitle: 'Framtidens parkering – i din hand.',
      description: 'Hitta, förboka och betala parkering, eller hyr ut din plats när den står tom. Allt samlat i AirPark-appen.',
    },
    overview: {
      title: 'All din parkering. I en och samma app.',
      description: 'AirPark samlar hela parkeringsupplevelsen i ett digitalt flöde – från planering till betalning och access. Förboka parkering i förväg, hantera ditt p-tillstånd och dela din plats när du inte använder den. Det är parkering – uppgraderad.',
    },
    appFeatures: {
      findParking: {
        title: 'Hitta & förboka din parkering',
        description: 'Slipp cirkulera runt kvarter efter kvarter. Med AirPark hittar du lediga parkeringsplatser i attraktiva lägen och bokar dem direkt i appen – innan du ens har startat bilen. Planera din parkering lika enkelt som du planerar ditt möte.',
      },
      bookAndPay: {
        title: 'Boka och betala – helt digitalt',
        description: 'Allt sker i appen. Betalning, kvitto och bokningsbekräftelse hanteras automatiskt – utan parkeringsautomater eller extra appar. Du ser dina aktiva bokningar, historik och betalningar samlade på ett ställe. Smidigt. Tryggt. Tidsbesparande.',
      },
      earnMoney: {
        title: 'Tjäna pengar på din parkeringsplats',
        description: 'När din parkeringsplats står tom kan den arbeta för dig. Gör den tillgänglig i appen med ett knapptryck och hyr ut den när du inte använder den. Du bestämmer pris och tillgänglighet – vi sköter bokning och betalning. En outnyttjad plats blir en ny intäktskälla.',
      },
      digitalPermit: {
        title: 'Ditt parkeringstillstånd – helt digitalt',
        description: 'Glöm fysiska tillstånd i framrutan. Med AirPark har du ditt parkeringstillstånd direkt i mobilen – alltid uppdaterat och alltid tillgängligt. Hantera ditt tillstånd, se giltighetstid och hyr ut din plats i andra hand när du inte använder den. All administration sker digitalt. Enklare för dig – effektivare för fastighetsägaren.',
      },
    },
    smarterParking: {
      title: 'Ett smartare sätt att parkera',
      subtitle: 'Slipp leta – Börja planera',
      description1: 'En svensk bilist lägger hundratals timmar på att leta parkering. Vi tycker att det finns bättre saker att göra med sin tid.',
      description2: 'Med AirPark hittar och förbokar du parkering nära dit du ska – i förväg. Du betalar direkt i appen och slipper automater, stress och osäkerhet.',
      description3: 'Har du en egen plats? Låt den jobba för dig när den står tom. Hyr ut den tryggt via appen och få intäkterna direkt till ditt konto.',
      description4: 'Ditt parkeringstillstånd är digitalt, alltid uppdaterat och alltid med dig.',
      conclusion: 'En app. Full kontroll. Smartare för dig – bättre för staden.',
    },
    mockup: 'AirPark App',
    features: {
      findParking: {
        title: 'Hitta parkering',
        description: 'Sök bland tusentals parkeringsplatser och hitta den perfekta platsen.',
      },
      booking: {
        title: 'Enkel bokning',
        description: 'Boka parkering på några sekunder. Välj tid och plats som passar dig.',
      },
      payment: {
        title: 'Säker betalning',
        description: 'Betala enkelt med kort eller Swish direkt i appen.',
      },
      rentOut: {
        title: 'Hyr ut',
        description: 'Tjäna pengar genom att hyra ut din parkeringsplats när du inte använder den.',
      },
      airpass: {
        title: 'AirPass-integration',
        description: 'Öppna garage och portar direkt från appen med AirPass.',
      },
      notifications: {
        title: 'Notifikationer',
        description: 'Få påminnelser om bokningar och när din parkering snart går ut.',
      },
    },
  },
  airpass: {
    hero: {
      title: 'AirPass',
      description: 'Öppna garage och portar direkt från AirPark-appen. En smart och säker lösning för modern parkeringsåtkomst.',
    },
    howItWorks: {
      title: 'Så fungerar AirPass',
      description: 'AirPass använder geolokalisering och säker identifiering för att ge behöriga användare tillgång till garage och parkeringsanläggningar.',
      step1: {
        title: 'Installation',
        description: 'AirPass installeras på din garageport eller grind.',
      },
      step2: {
        title: 'Anslutning',
        description: 'Enheten kopplas till AirPark-plattformen.',
      },
      step3: {
        title: 'Användning',
        description: 'Med giltigt tillstånd öppnas porten via appen.',
      },
    },
    features: {
      access: {
        title: 'Smidig åtkomst',
        description: 'Öppna portar och garage direkt från din telefon. Inga nycklar eller fjärrkontroller.',
      },
      geolocation: {
        title: 'Geolokalisering',
        description: 'Appen känner av när du är nära och gör det enkelt att öppna porten.',
      },
      security: {
        title: 'Hög säkerhet',
        description: 'Säker identifiering säkerställer att endast behöriga användare får tillgång.',
      },
      instant: {
        title: 'Omedelbar åtkomst',
        description: 'Ingen väntan. Porten öppnas direkt när du trycker i appen.',
      },
      app: {
        title: 'Integrerat i appen',
        description: 'AirPass är helt integrerat i AirPark-appen. Ingen extra app behövs.',
      },
      installation: {
        title: 'Enkel installation',
        description: 'AirPass installeras snabbt och enkelt på de flesta portar och grindar.',
      },
    },
    pricing: {
      title: 'Prissättning',
      description: 'AirPass är en kostnadseffektiv lösning för modern åtkomstkontroll.',
    },
  },
  news: {
    title: 'Nyheter',
    description: 'Håll dig uppdaterad med de senaste nyheterna från AirPark',
    readMore: 'Läs mer',
    readTime: 'läsning',
    locale: 'sv-SE',
    categories: {
      product: 'Produkt',
      partnership: 'Partnerskap',
      sustainability: 'Hållbarhet',
      company: 'Företag',
      tips: 'Tips & Råd',
    },
    articles: {
      article1: {
        title: 'Ny funktion: AirPark Communities lanseras',
        excerpt: 'Vi är glada att presentera AirPark Communities - en ny funktion som gör det möjligt för bostadsrättsföreningar och fastighetsägare att skapa slutna parkeringsgemenskaper.',
      },
      article2: {
        title: 'AirPark samarbetar med Rikshem',
        excerpt: 'Vi är stolta över att tillkännage vårt nya partnerskap med Rikshem, en av Sveriges ledande fastighetsbolag. Tillsammans kommer vi att revolutionera parkering i hela landet.',
      },
      article3: {
        title: 'Så bidrar AirPark till en grönare framtid',
        excerpt: 'Genom att optimera användningen av befintliga parkeringsplatser minskar vi behovet av nybyggnation och bidrar till en mer hållbar stadsutveckling.',
      },
      article4: {
        title: 'AirPass - Framtidens parkeringslösning',
        excerpt: 'Med AirPass kan du öppna garage och portar direkt från appen. Läs mer om hur denna smarta lösning förenklar vardagen för både fastighetsägare och användare.',
      },
      article5: {
        title: 'AirPark växer - 50 000 användare',
        excerpt: 'Vi firar en viktig milstolpe! AirPark har nu över 50 000 registrerade användare och fortsätter att växa snabbt över hela Sverige.',
      },
      article6: {
        title: '5 tips för att maximera intäkterna från din parkeringsplats',
        excerpt: 'Vill du tjäna mer på din oanvända parkeringsplats? Här är våra bästa tips för att optimera pris, tillgänglighet och attraktivitet.',
      },
    },
  },
  privacy: {
    title: 'Integritetspolicy',
    lastUpdated: 'Senast uppdaterad',
    sections: {
      intro: {
        title: 'Introduktion',
        content: 'AirPark AB ("vi", "oss", "vår") värnar om din integritet. Denna policy beskriver hur vi samlar in, använder och skyddar dina personuppgifter i enlighet med GDPR och svensk dataskyddslagstiftning.',
      },
      dataController: {
        title: 'Personuppgiftsansvarig',
        content: 'AirPark AB är personuppgiftsansvarig för behandlingen av dina personuppgifter.',
      },
      dataCollected: {
        title: 'Vilka uppgifter samlar vi in?',
        content: 'Vi samlar in följande typer av personuppgifter:',
        items: {
          contact: 'Kontaktuppgifter (namn, e-post, telefon)',
          company: 'Företagsinformation (företagsnamn, organisationsnummer)',
          usage: 'Användningsdata (hur du använder våra tjänster)',
          technical: 'Teknisk data (IP-adress, webbläsare, enhet)',
        },
      },
      purpose: {
        title: 'Varför behandlar vi dina uppgifter?',
        content: 'Vi behandlar dina personuppgifter för följande ändamål:',
        items: {
          service: 'Tillhandahålla och förbättra våra tjänster',
          communication: 'Kommunicera med dig om våra tjänster',
          improvement: 'Analysera och förbättra användarupplevelsen',
          legal: 'Uppfylla rättsliga skyldigheter',
        },
      },
      rights: {
        title: 'Dina rättigheter',
        content: 'Enligt GDPR har du följande rättigheter:',
        items: {
          access: 'Rätt till tillgång - begära information om vilka uppgifter vi har om dig',
          rectification: 'Rätt till rättelse - korrigera felaktiga uppgifter',
          erasure: 'Rätt till radering - begära att vi raderar dina uppgifter',
          restriction: 'Rätt till begränsning - begränsa hur vi använder dina uppgifter',
          portability: 'Rätt till dataportabilitet - få ut dina uppgifter i maskinläsbart format',
          objection: 'Rätt att invända - invända mot viss behandling',
        },
      },
      thirdParty: {
        title: 'Tredjepartstjänster',
        content: 'Vi använder följande tredjepartstjänster som kan behandla dina personuppgifter:',
      },
      contact: {
        title: 'Kontakta oss',
        content: 'Om du har frågor om hur vi behandlar dina personuppgifter eller vill utöva dina rättigheter, kontakta oss.',
      },
    },
  },
  cookies: {
    title: 'Cookiepolicy',
    lastUpdated: 'Senast uppdaterad',
    table: {
      service: 'Tjänst',
      purpose: 'Syfte',
      type: 'Typ',
      analytics: 'Webbanalys och statistik',
      marketing: 'Marknadsföring och spårning',
      tagManager: 'Tagghantering',
    },
    sections: {
      what: {
        title: 'Vad är cookies?',
        content: 'Cookies är små textfiler som lagras på din enhet när du besöker vår webbplats. De hjälper oss att förbättra din upplevelse och förstå hur webbplatsen används.',
      },
      types: {
        title: 'Typer av cookies vi använder',
        necessary: {
          title: 'Nödvändiga cookies',
          description: 'Dessa cookies är nödvändiga för att webbplatsen ska fungera korrekt. De kan inte stängas av.',
          status: 'Alltid aktiva',
        },
        functional: {
          title: 'Funktionella cookies',
          description: 'Dessa cookies möjliggör förbättrad funktionalitet och personalisering, som språkinställningar.',
          status: 'Kräver samtycke',
        },
        analytics: {
          title: 'Statistik-cookies',
          description: 'Dessa cookies hjälper oss att förstå hur besökare interagerar med webbplatsen genom att samla in anonym information.',
          status: 'Kräver samtycke',
        },
        marketing: {
          title: 'Marknadsförings-cookies',
          description: 'Dessa cookies används för att visa relevanta annonser och mäta effektiviteten av marknadsföringskampanjer.',
          status: 'Kräver samtycke',
        },
      },
      thirdParty: {
        title: 'Tredjepartscookies',
        content: 'Vi använder följande tredjepartstjänster som kan sätta cookies på din enhet:',
      },
      manage: {
        title: 'Hantera dina cookie-inställningar',
        content: 'Du kan när som helst ändra dina cookie-inställningar genom att klicka på knappen nedan.',
        button: 'Hantera cookies',
      },
      contact: {
        title: 'Kontakta oss',
        content: 'Om du har frågor om vår användning av cookies, kontakta oss.',
      },
    },
  },
  targetAudience: {
    title: 'Vem är du?',
    subtitle: 'AirPark erbjuder skräddarsydda lösningar för olika typer av verksamheter',
    learnMore: 'Läs mer',
    disclaimer: '* Resultat varierar beroende på fastighet och användning',
    propertyOwner: {
      tab: 'Fastighetsägare',
      title: 'Fastighetsägare',
      description: 'Samla uthyrning, tillstånd, betalningar och uppföljning i ett helt automatiserat affärssystem – som ger full kontroll över nyttjandegrad, intäkter och administration.',
      benefit1: 'Öka intäkterna med upp till 40% genom smart uthyrning*',
      benefit2: 'Automatiserad fakturering och betalningshantering utan manuellt arbete',
      benefit3: 'Realtidsöverblick över beläggning och intäkter & användning',
      benefit4: 'Full kontroll och spårbarhet i hela flödet',
    },
    municipality: {
      tab: 'Kommuner',
      title: 'Kommuner & offentlig sektor',
      description: 'Samla tillstånd och uppföljning i ett automatiserat system ökar nyttjandegraden av befintliga parkeringsytor – vilket minskar söktrafik, utsläpp och behovet av nya parkeringsanläggningar.',
      benefit1: 'Minska söktrafik och utsläpp i stadskärnan',
      benefit2: 'Minskad administration och ökad nyttjandegrad',
      benefit3: 'Digital hantering och uppföljning av parkeringsbeståndet',
      benefit4: 'Datadriven planering för framtidens mobilitet',
    },
    parkingCompany: {
      tab: 'Parkeringsbolag',
      title: 'Parkeringsbolag',
      description: 'Effektivisera erbjudandet med ett digitalt system. AirPark automatiserar uthyrning, tillstånd, betalningar och kundhantering – som ett smart komplement till traditionell parkeringsdrift. Resultatet är högre nyttjandegrad, nya intäkter och en skalbar lösning utan ökad administration.',
      benefit1: 'Digital uthyrning och tillstånd som kompletterar befintlig parkeringsövervakning',
      benefit2: 'Automatiserad hantering av kunder, betalningar och tillstånd – helt utan manuellt arbete',
      benefit3: 'Skapar nya intäkter och högre intäkt per parkeringsyta genom ökad nyttjandegrad',
      benefit4: 'Skalbar plattform som snabbt kan rullas ut till nya områden och uppdrag utan ökade driftkostnader',
    },
    coop: {
      tab: 'BRF:er',
      title: 'Bostadsrättsföreningar',
      description: 'Skapa mer värde av föreningens parkeringsplatser genom kontrollerad och digital samnyttjande. Med AirPark kan boende hyra ut sina platser när de inte används – helt automatiserat – samtidigt som föreningen behåller full kontroll och får del av intäkterna.',
      benefit1: 'Trygg och reglerad andrahandsuthyrning – enligt föreningens villkor',
      benefit2: 'Nya intäkter till både boende och förening genom bättre nyttjande av befintliga platser',
      benefit3: 'Automatiserad hantering av tillstånd, uthyrning och betalningar',
      benefit4: 'Skalbar lösning som fungerar även när fler vill hyra ut eller efterfrågan ökar',
      benefit5: 'Full överblick över användning, intäkter och tillstånd – i realtid',
    },
  },
}

